import { React } from "react";
import { Modal, Container } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { VideoURLs } from "../../models/constants/videoURLs";
import { useNavigate } from "react-router-dom";
import { VideoPlayer } from "../VideoPlayer/VideoPlayer";

export const VideoModal = ({ video, opened, close }) => {
  const isSmartMobile = useMediaQuery("(max-width: 576px)", true, {
    getInitialValueInEffect: false,
  });
  const navigate = useNavigate();
  const getVideoUrl = (video) => {
    switch (video) {
      case "homepageVideo":
        return VideoURLs.homepageVideo;
      case "reviewVideo":
        return VideoURLs.reviewVideo;
      case "quotePageVideo":
        return VideoURLs.quotePageVideo;
      default:
        navigate("/");
        return null;
    }
  };
  const video_url = video ? getVideoUrl(video) : null;

  const onClose = () => {
    navigate("/");
    close();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size={video === "reviewVideo" ? "auto" : "xl"}
      fullScreen={isSmartMobile}
      transitionProps={{
        transition: "slide-up",
        duration: 200,
        timingFunction: "ease",
      }}
      closeOnClickOutside={true}
      centered
      withOverlay
    >
      <Container>
        <VideoPlayer
          video_url={video_url}
          reviewClass={video === "reviewVideo" ? "review-video-wrapper" : null}
          videoModal={true}
          h={video !== "reviewVideo" && !isSmartMobile ? "425px" : null}
        />
      </Container>
    </Modal>
  );
};
